import React, { useRef } from 'react';

import { Goals } from './components/goals/Goals';
import { AchievedResult } from './components/achievedresult/AchievedResult';
import { LifeWithoutLiven } from './components/withoutliven/WithoutLiven';
import { LifeWithLiven } from './components/lifewithliven/LifeWithLiven';
import { PeopleAsk } from './components/peopleask/PeopleAsk';
import { UserPlans } from './components/userplans/UserPlans';
import { MoneyGuarantee } from './components/moneyguarantee/MoneyGuarantee';
import { LivenProud } from './components/livenproud/LivenProud';
import { withDefaultProduct } from 'subscription/withDefaultProduct/withDefaultProduct';
import { SingleProductPayment } from './components/singleproductpayment/SingleProductPayment';
import { Header } from './components/header/Header';

import { Footer } from 'components/footer/Footer';
import { PlanBox } from './components/planbox/PlanBox';
import { Recurly } from 'subscription/recurly/Recurly';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import styles from './styles.module.scss';
import { RecaptchaFooter } from './components/recaptchafoooter/RecaptchaFooter';
import { useSingleProductLogic } from 'subscription/singleproduct/SingleProductPayment.hook';

export const LivenSubscription = withDefaultProduct(({ product, products }) => {
  const paymentFormRef = useRef<HTMLDivElement>(null);

  const { product: selectedProduct } = useSingleProductLogic({
    defaultProduct: product,
    products,
    paymentFormRef,
  });

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY || ''}
      scriptProps={{
        async: false,
        defer: false,
        appendTo: 'head',
        nonce: undefined,
      }}
    >
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <Header
            defaultProduct={product}
            products={products}
            paymentFormRef={paymentFormRef}
          />
          <PlanBox />
          <SingleProductPayment
            defaultProduct={product}
            products={products}
            paymentFormRef={paymentFormRef}
          />
          <AchievedResult />
          <Goals />
          <LifeWithoutLiven />
          <LifeWithLiven />
          <LivenProud />
          <PeopleAsk />
          <UserPlans />
          <SingleProductPayment
            defaultProduct={product}
            products={products}
            paymentFormRef={paymentFormRef}
          />
          <MoneyGuarantee />
          <div ref={paymentFormRef}>
            <Recurly product={selectedProduct} />
          </div>{' '}
          <RecaptchaFooter />
          <Footer className={styles.footer} />
        </div>
      </div>
    </GoogleReCaptchaProvider>
  );
});
